import { Button, Icon, IconButton, Stack, TextField } from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";

export default function GoToPageDialog(props: {
    current: number;
    max: number;
    onChange: (page: number) => void;
}) {
    const [page, setPage] = useState(props.current);

    const { closeDialog } = useContext(DialogContext);

    const handlePageChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const p = parseInt(event.target.value);

        if (!p || p <= 0 || isNaN(p)) {
            return;
        }

        setPage(parseInt(event.target.value) ?? 0);
    };

    const goToPage = () => {
        props.onChange(page);
        closeDialog();
    };

    const goToPrevPage = () => {
        if (page <= 1) {
            return;
        }
        setPage(page - 1);
    };

    const goToNextPage = () => {
        setPage(page + 1);
    };

    return (
        <DialogContainer>
            <DialogHeader title="انتخاب صفحه" />

            <Stack spacing={2} sx={{ p: 2 }}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <IconButton color="secondary" onClick={goToPrevPage}>
                        <Icon>arrow_forward</Icon>
                    </IconButton>

                    <TextField
                        size="small"
                        value={page}
                        onChange={handlePageChange}
                    />

                    <IconButton color="secondary" onClick={goToNextPage}>
                        <Icon>arrow_back</Icon>
                    </IconButton>
                </Stack>

                <Button variant="contained" onClick={goToPage}>
                    رفتن به صفحه انتخاب شده
                </Button>
            </Stack>
        </DialogContainer>
    );
}
